import { InfoStripeModel } from '@/models/info-stripe.model';
import { ValidatorResult } from '@/models/validation-result.model';
import { CrudService } from './crud.service';

export class InfoStripeService {
  private crudService: CrudService<InfoStripeModel>;

  constructor() {
    this.crudService = new CrudService<InfoStripeModel>('info-stripes');
  }

  public async getInfoStripes(countryId: string): Promise<ValidatorResult<InfoStripeModel[]>> {
    return await this.crudService.do('get', `${countryId}`, undefined, undefined, 'silent');
  }
}
